import React from 'react'

function Disclaimer() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins mt-5 lg:m-[100px]">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Disclaimer</h2>
      <div className="space-y-8 max-w-4xl">

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">General Information</h3>
            <p className="text-sm text-white mt-4">
              The content provided on <span className="text-btn-color font-bold">FinzAid.com</span> is for informational purposes only. While we strive to ensure accuracy, all financial and trading advice or information should be used at your own risk. FinzAid makes no warranties about the completeness, reliability, or accuracy of this information.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">No Professional Advice</h3>
            <p className="text-sm text-white mt-4">
              <span className="text-btn-color font-bold">FinzAid.com</span> does not offer personalized financial or investment advice. Any information provided on the website should not be interpreted as professional advice or a recommendation for making financial decisions.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">External Links Disclaimer</h3>
            <p className="text-sm text-white mt-4">
              Our website may contain links to external websites that are not provided or maintained by <span className="text-btn-color font-bold">FinzAid.com</span>. We do not guarantee the accuracy, relevance, or completeness of the information on these external websites.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Copyright</h3>
            <p className="text-sm text-white mt-4">
              All videos and content uploaded by <span className="text-btn-color font-bold">FinzAid.com</span> are our exclusive property. Reproduction, distribution, or use of this content without written consent is strictly prohibited.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Limitation of Liability</h3>
            <p className="text-sm text-white mt-4">
              Under no circumstances shall <span className="text-btn-color font-bold">FinzAid.com</span> be held liable for any loss or damage resulting from the use of the content on this site, including but not limited to, indirect, consequential, or punitive damages.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer;
